/**
 * The prefix of the {@code localStorage} key into which {@link storeConfig}
 * stores and from which {@link restoreConfig} restores.
 *
 * @protected
 * @type string
 */
export const _CONFIG_STORE_PREFIX = "config.js";
/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */
export const TOOLBAR_BUTTONS = [
    "camera",
    "chat",
    "closedcaptions",
    "desktop",
    "download",
    "embedmeeting",
    "etherpad",
    "feedback",
    "filmstrip",
    "fullscreen",
    "hangup",
    "help",
    "highlight",
    "invite",
    "linktosalesforce",
    "livestreaming",
    "microphone",
    "mute-everyone",
    "mute-video-everyone",
    "participants-pane",
    "material-list",
    "profile",
    "raisehand",
    "recording",
    "previous-page",
    "next-page",
    "go-teacher-page",
    "security",
    "select-background",
    "face-registration",
    "settings",
    "shareaudio",
    "noisesuppression",
    "face-recognition",
    "face-mesh",
    "picture-in-picture",
    "sharedvideo",
    "shortcuts",
    "stats",
    "tileview",
    "toggle-camera",
    "videoquality",
    "whiteboard",
];
/**
 * The toolbar buttons to show on premeeting screens.
 */
export const PREMEETING_BUTTONS = [
    "microphone",
    "camera",
    "select-background",
    "invite",
    "settings",
    "face-registration"
];
/**
 * The toolbar buttons to show on 3rdParty prejoin screen.
 */
export const THIRD_PARTY_PREJOIN_BUTTONS = [
    "microphone",
    "camera",
    "select-background",
];
